import { Context, createContext } from "react";
import AnalyticsService from "./analyticsService";

const analyticsContext: Context<AnalyticsService> = createContext(
  new AnalyticsService()
);

export default analyticsContext;
